import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Route, Routes, useLocation } from "react-router-dom";
import APPCONFIG from "constants/appConfig";
import axios from "axios";
import { getUser, redirectAndSaveState, setUser } from "services/auth";
import Sidenav from "components/Layout/Sidenav";
import Header from "components/Layout/Header";
import Footer from "components/Layout/Footer";
import Orders from "routes/app/routes/Orders/Orders";
import GroupOrders from "routes/app/routes/GroupOrders/GroupOrders";
import Schedule from "routes/app/routes/Schedule/Schedule";
import Menus from "routes/app/routes/Menus/Menus";
import MenuItem from "routes/app/routes/Menus/MenuItem";
import exception from "routes/exception";
import Loader from "components/Loading/Loader";
import { appdataSelector, appdata_getHolidays, appdata_setAppState, appdata_setSnackbar } from "reducers/appdata/appdata";
import { useDispatch } from "react-redux";
import Holidays from "routes/app/routes/Holidays/Holidays";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import logo from '../../../assets/images/besi_logo.png';
import ExcelConversion from "routes/app/routes/ExcelConversion/ExcelConversion";

function MainApp(props) {
  console.log("new Mainapp", props);
  const dispatch = useDispatch();
  const location = useLocation();
  const appdata = useSelector(appdataSelector);
  const [hasLogin, setHasLogin] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  const handleCloseModal = () => {
     setOpenModal(false); 
  };

  useEffect(() => {
    // execute on location change
    console.log("Location changed!", location.pathname);

    switch (location.pathname) {
      case "/app/orders":
        dispatch(appdata_setAppState("orders"));
        break;
      case "/app/grouporders":
        dispatch(appdata_setAppState("grouporders"));
        break;
      case "/app/schedule":
        dispatch(appdata_setAppState("schedule"));
        break;
      case "/app/schedule/true":
        dispatch(appdata_setAppState("scheduleprint"));
        break;
      case "/app/menus":
        dispatch(appdata_setAppState("menus"));
        break;
    }
  }, [location]);

  const getMe = () => {
    console.log("getMe");
    axios
      .get(APPCONFIG.host + "api/me", {
        withCredentials: true,
        timeout: APPCONFIG.axiosTimeout
      })
      .then(res => {
        console.log("MainApp - getme - got user", res.data);
        setUser({ ...getUser(), ...res.data });
        if (res.data.employeeId) {
          setHasLogin(true);
        } else {
          if (hasLogin) setHasLogin(false);
          // @TODO employeeId is not set what should we do?
          window.location.href =
            APPCONFIG.appFrontendHostname + "#/user/notallowed";
        }
      })
      .catch(error => {
        console.error(error);
        if (
          error.response &&
          error.response.status &&
          error.response.status === 403
        ) {
          // user not in groups
          window.location.href =
            APPCONFIG.appFrontendHostname + "#/user/notallowed";
        } else {
          redirectAndSaveState(error);
        }
        // handle error
      });
  };

  const getHolidays = () => {
    dispatch(appdata_getHolidays())
  }

  useEffect(() => {
    console.log("Mainapp - init");

    const isRoot = location && location.hash === "" ? true : false;
    if (isRoot) {
      console.log("MainApp is root, frontend:" + APPCONFIG.appFrontendHostname);
      let url = APPCONFIG.appFrontendHostname + "#/app/orders";
      window.location.href = url;
    }

    getHolidays();

    getMe();

    sessionStorage.removeItem("besiUser4");
    let sesionId = localStorage.getItem("laravelSession");
    if (sesionId) {
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "laravelSession"
      );
    }

    if (!openModal) {
      const currentDate = new Date();
      const startDate = new Date('2025-05-19');
      const endDate = new Date('2025-05-23');

      if (currentDate >= startDate && currentDate <= endDate) {
        setOpenModal(true);
      }

    }
  }, []);

  if (!hasLogin) {
    return (
      <div className="d-flex justify-content-center">
        <Loader></Loader>
      </div>
    );
  }

  if (!getUser().isAllowedUser) {

    let textToDisplay = "You are not allowed to use this APP. Please contact your system admin!";

    const currentDate = new Date();
    const startDate = new Date('2025-05-21');
    const endDate = new Date('2025-05-27');

    if ((currentDate >= startDate && currentDate <= endDate)) {
      textToDisplay = "We are testing this app, please be patient!";
    }

    return (
      <div className="d-flex justify-content-center mt-4">
        {textToDisplay}
      </div>
    );
  }

  

  
  return (
    <div className="main-app-container">
      <Modal
        onClick={handleCloseModal}
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <div className="modal-content" style={{ 
          width: window.innerWidth <= 768 ? '90%' : '50%', 
          height: window.innerWidth <= 768 ? '90%' : '50%', 
          margin: 'auto', 
          border: '2px solid #008752', 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center', 
          alignItems: 'center', 
          textAlign: 'center',
          backgroundColor: 'white',
          borderRadius: '10px'
        }}>
          <img class="mb-4"src={logo} alt="BESI" />
          <h2 id="simple-modal-title">Important Notice</h2>
          <br></br>
          <p id="simple-modal-description">
            <span style={{ color: 'red' }}>This app will be offline from the 22nd of May to the 26th of May.</span>
            <br></br>
            <br></br>
            Please make sure you order your lunch for <b>Thursday, 22nd of May to Friday, 30th of May <span style={{ color: 'red' }}>before 11:00 AM on Wednesday, 21st of May</span></b>.
            <br></br>
            Changes will <b>not be possible</b> after 11:00 AM on Wednesday, 21st of May.
            <br></br>
            <br></br>
          </p>
          
          <Button variant="contained" onClick={handleCloseModal}>
            Close
          </Button>
        </div>
      </Modal>
      <Sidenav />
      <section id="page-container" className="app-page-container">
        <Header />
        <div className="app-content-wrapper">
          <div className="app-content">
            <div className="h-100">
              <Routes>
                <Route path="/orders" element={<Orders />} />

                <Route path="/grouporders" element={<GroupOrders />} />

                <Route path="/schedule/:print?" element={<Schedule />} />
                <Route path="/menus" element={<Menus />} />
                <Route path="/menuitem" element={<MenuItem />} />
                <Route path="/menuitem/:menu_numb" element={<MenuItem />} />
                <Route path="/holidays" element={<Holidays />} />
                <Route path="/ExcelConversion" element={<ExcelConversion/>}/>

                <Route
                  //path={`${match.url}/exception`}
                  path="/exception"
                  element={<exception />}
                />
              </Routes>

              <Snackbar
                className="mt-6"
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={appdata.snackbar.open}
                onClose={() => {
                  dispatch(appdata_setSnackbar({ open: false }));
                }}
                key={"ilovesnacks"}
                autoHideDuration={5000}
              >
                <Alert severity={appdata.snackbar.severity}>
                  {appdata.snackbar.message}
                </Alert>
              </Snackbar>

            </div>
          </div>
          <Footer />
        </div>
      </section>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => ({});

export default connect(mapStateToProps)(MainApp);
